import { ProtocolContentData } from "../../protocol";
export default class PilotOnBoardData extends ProtocolContentData {
    name;
    freeText;
    ladderPosition;
    boarding;
    constructor(name, ladderPosition, boarding, freeText) {
        super();
        this.name = name;
        this.ladderPosition = ladderPosition;
        this.freeText = freeText;
        this.boarding = boarding;
    }
}
//# sourceMappingURL=PilotOnBoardData.js.map